// Lionhead mark — recolored, transparent-background PNG derived from the
// provided source logo. Rendered as a plain <img> so it stays crisp at any
// size and is a single HTTP asset (also used as the favicon).

export function LionMark({ size = 40, className = "" }) {
  return (
    <img
      src="/brand/lion-mark.png"
      alt="Lionhead International"
      width={size}
      height={size}
      className={className}
      style={{ width: size, height: size, objectFit: "contain", display: "block" }}
      draggable={false}
    />
  );
}

export default LionMark;
